import React from "react"

import {
	TouchApp as TouchAppIcon
} from "@material-ui/icons"

import { TriggerItemProps } from "@/protocols/chatBotConstructor"

import NewTriggerItemContainer from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/NewTriggerItemContainer"
import { colors } from "@/styles/colors"

const AttendanceTakenTriggerItem: React.FC<TriggerItemProps> = (props) => {
	const {
		onDelete
	} = props

	return (
		<NewTriggerItemContainer
			title="Atendimento"
			description="Bot acionado quando o atendimento é assumido"
			icon={(
				<TouchAppIcon
					style={{
						width: "32px",
						height: "32px",
						fill: colors.getPrimaryColor()
					}}
				/>
			)}
			onDelete={onDelete}
		/>
	)
}

export default AttendanceTakenTriggerItem
